export const locale = {
    lang: 'pt-br',
    data: {
        'NAV': {
            'HOME': 'Início',
            'CATEGORIAS': 'Categorias',
            'EMISSAO': 'Emissão',
            'VOUCHERS' : 'Vouchers',
            'RH' : 'Recursos Humanos',
            'DEPARAPROMOTOR' : 'De / Para Promotor',
            'FUNCIONARIOS' : 'Funcionários',
            'CADASTRO'  :   'Cadastro',
            'CAMBIO': 'Câmbio',
            'CUPOM':    'Cupom'
        }
    }
};
